var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletSuccessCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M16 3.42871C22.943 3.42871 28.5713 9.05699 28.5713 16C28.5713 22.943 22.943 28.5713 16 28.5713C9.05699 28.5713 3.42871 22.943 3.42871 16C3.42871 9.05699 9.05699 3.42871 16 3.42871ZM16 5.71387C10.3194 5.71387 5.71387 10.3194 5.71387 16C5.71387 21.6806 10.3194 26.2861 16 26.2861C21.6806 26.2861 26.2861 21.6806 26.2861 16C26.2861 10.3194 21.6806 5.71387 16 5.71387ZM19.7627 11.7637C20.2088 11.3171 20.9324 11.3176 21.3789 11.7637C21.8251 12.2097 21.8266 12.9334 21.3809 13.3799L14.3477 20.4199C14.1287 20.6391 13.8293 20.76 13.5195 20.7549C13.2097 20.7497 12.9137 20.6171 12.7021 20.3906L9.3291 16.7812C8.89867 16.3203 8.92241 15.5959 9.38281 15.165C9.84376 14.7344 10.568 14.7583 10.999 15.2188L13.5664 17.9639L19.7627 11.7637Z",
    fill: "#008F4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletSuccessCheckIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-success-check-icon.ae615b2e18e7ad4f55c54918d0631df1.svg";
export { ForwardRef as ReactComponent };